export const getErrorMessage = (error, fallback = 'Something went wrong') => {
  if (error?.response?.data?.detail) {
    const detail = error.response.data.detail;

    if (typeof detail === 'string' && detail.trim()) {
      return detail;
    }

    if (Array.isArray(detail) && detail.length > 0) {
      const first = detail[0];
      if (typeof first === 'string') return first;
      if (first?.msg && typeof first.msg === 'string') return first.msg;
    }

    if (detail && typeof detail === 'object' && typeof detail.message === 'string') {
      return detail.message;
    }
  }

  if (typeof error?.response?.data?.message === 'string' && error.response.data.message.trim()) {
    return error.response.data.message;
  }

  if (typeof error?.message === 'string' && error.message.trim()) {
    return error.message;
  }

  return fallback;
};
